<template>
  <div class="custom-toast" @click="redirectToPage">
    <div class="toast-content">
      <h6>{{ title }}</h6>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: String,
    message: String,
    type: String, // 'event', 'alert', 'alarm'
    router: Object,
    event_alert_data: Object,
    event_index: Number,
    show_nav_bar_status: Boolean,
    show_right_nav_bar: Function,
    switch_logs_tab: Function,
  },
  methods: {
    closeToast() {
      this.$emit("close-toast");
    },
    redirectToPage() {
      if (this.type == "event") {
        // "/event/:deviceid/:id/:subid/:startTimestamp"
        let path =
          `event/${this.event_alert_data.deviceid}/` +
          `${this.event_alert_data.eventid}/` +
          `${this.event_index}/` +
          `${this.event_alert_data.eventsmessage.eventsmsgList[this.event_index].starttimestamp}`;
        window.open(`/${path}`, "_blank");
      } else {
        //For alerts/alarms open SideBar >> logs tab
        // If the right navigation bar is closed, open it and switch to the Logs tab.
        if(this.show_nav_bar_status==false){
          this.show_right_nav_bar();
          this.switch_logs_tab(1);
        }
        // If the right navigation bar is already open, switch to the Logs tab.
        else{
          this.switch_logs_tab(1);
        }
      }
    },
  },
};
</script>

<style scoped>
.custom-toast {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  padding: 0;
  border: none;
  font-size: 14px;
  width: 300px;
}

.toast-icon {
  margin-right: 8px;
}

.toast-content h6 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.toast-content p {
  margin: 0;
  font-size: 14px;
}
</style>
